export const downloadReferentialTemplate = (template) => {
  const blob = new Blob([JSON.stringify(template, null, 2)], {
    type: 'application/json',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = `referential-template-${template.ref}.json`
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
